export function validateEmail(email) {
  email.trim();
  const emailPattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
  return emailPattern.test(email);
}

export function getReceiversEmail(receiversString) {
  const receiversArray = receiversString.split(",");
  const receivers = receiversArray.map((receiver) => {
    return { email: receiver, name: "Atrare Consultores" };
  });
  return receivers;
}
